import { registerVueBundle } from './core/createApp'

const components = {
	'get-an-offer': () => import('./components/GetAnOfferForm'),
	'advertising-modal': () => import('./components/modals/AdvertisingModal.vue'),
	'agency-modal-form': () => import('./components/agency/AgencyModal.vue'),
	'agency-email-modal-form': () => import('./components/agency/AgencyEmailModal.vue'),
	'contact-form': () => import('./components/ContactForm'),
	'agency-contact-form': () => import('./components/agency/AgencyContactForm'),
	'agency-event-form': () => import('./components/agency/AgencyEventForm.vue'),
	'contents-section': () => import('./components/ContentsSection'),
	'dropdown': () => import('./components/form-items/dropdown'),
	'agency-list': () => import('./components/agency/AgencyListPage.vue'),
	'multiple-select': () => import('./components/form-items/MultipleSelect.vue'),
	'custom-select': () => import('./components/form-items/CustomSelect.vue'),
	'profile-button': () => import('./components/profileButton'),
};

registerVueBundle({
	components,
	mountOn: 'load',
});
